import React from 'react';
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { isSpecial } from '../lib';

const getLogo = (team) => {
  if (!team?.logoUrl) return null
  return team.logoUrl;
}

const getLink = (team, scheduleId, groupId) => {
  const base = `/teams/${team.id}`;
  if (scheduleId && groupId) return `${base}?scheduleId=${scheduleId}&groupId=${groupId}`
  if (scheduleId) return `${base}?scheduleId=${scheduleId}`
  return base;
}

export const Logo = ({ team }) => {
  if (!team) return <div className={cn("team-logo")}></div>;
  return <div className={cn("team-logo")} style={{
    backgroundImage: `url(${getLogo(team)})`,
  }} alt={team.name}></div>
}

const Team = ({ team, reverse, style = 'minimal' }) => {
  const { formatMessage } = useIntl()
  const hideLogo = style === 'minimal';
  return <div className={cn("d-flex flex-row", { 'flex-row-reverse': reverse })} style={{ minWidth: '125px' }}>
    {!hideLogo && <div className={reverse ? 'pl-2' : 'pr-2'}>
      <Logo team={team} />
    </div>}
    <div className="d-flex flex-fill flex-column justify-content-center">
      <span className={cn("team-name", "text-uppercase", { 'text-right': reverse })}>{team?.name || formatMessage({ id: `common.lang.tbd` })}</span>
    </div>
  </div>
}

export default ({ team, scheduleId, groupId, ...props }) => {
  if (isSpecial(team)) return <Team team={team} {...props} />
  return <Link className="team-link" to={getLink(team, scheduleId, groupId)} onClick={e => e.stopPropagation()}>
    <Team team={team} {...props} />
  </Link>
}
